import React, {Component} from 'react';
import Chart from 'chart.js';
import {numberFormat} from '../utils/number';

export default class ChartComponent extends Component {
    constructor(props) {
        super(props);

        this.canvasRef = React.createRef();
        this.chartInstance = null;

        this.updateData = this.updateData.bind(this);
    }

    componentDidMount() {
        let chartContext = this.canvasRef.current.getContext("2d");

        const {type, hasIntegerValues} = this.props;

        this.chartInstance = new Chart(chartContext, {
            type: type || "pie",
            data: {
                labels: [],
                datasets: [],
            },
            options: {
                maintainAspectRatio: false,
                responsive: true,
                legend: {
                    display: false,
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

                            const num = hasIntegerValues
                                ? numberFormat(value, 0, '', '.')
                                : numberFormat(value, 2, ',', '.');

                            return data.labels[tooltipItem.index] + ': ' + num;
                        },
                        title: function () {
                        },
                    }
                }
            },
        });
    }

    updateData(data) {
        this.chartInstance.data = data;
        this.chartInstance.update();
    }

    render() {
        return (
            <canvas ref={this.canvasRef} style={{height: '400px'}}></canvas>
        );
    }
}
